import { CALLING_DETAILS } from '../utils/constants.json';

const INITIAL_STATE = {
  numberList: '',
  sendBirdFlags: '',
  merchantName: '',
  mid: '',
  isCloudTelephonyActive: false,
  isSendBirdActive: false,
  isBossNumberAvailable: false,
};

/**
 * Reducer - to update services state
 * @param {Object} state initial/default services state.
 * @param {Object} action to be performed
 * @return {Object} new services state
 */
export default function (state = INITIAL_STATE, action) {
  const { payload } = action;
  switch (action.type) {
    case CALLING_DETAILS.SUCCESS:
      return { ...state, ...payload };
    case CALLING_DETAILS.FAILURE:
      return { ...INITIAL_STATE };
    default:
      return { ...state };
  }
}
